/** Observations and client invalidation identities are never provider authority. */
export interface RegisteredEnvironment {
  readonly environmentId: string;
  readonly name: string;
  readonly account: string | null;
  readonly legacyKey?: string;
  readonly aliases?: readonly string[];
  /** False means metadata was deliberately omitted from the selector projection. */
  readonly accountDisclosed?: boolean;
  readonly healthReadable?: boolean;
  readonly region: 'ap-southeast-2';
  readonly lifecycle: 'ready' | 'planned' | 'unknown';
}
export type ScopeIntent =
  | { kind: 'unspecified' }
  | { kind: 'all' }
  | { kind: 'environment'; environmentId: string }
  | { kind: 'invalid'; reason: string };
export type RegistryObservation =
  | { kind: 'pending' }
  | { kind: 'denied' }
  | { kind: 'unavailable'; reason: string }
  | { kind: 'available'; source: string; observedAt: string | null; rows: readonly RegisteredEnvironment[] };
export type ResolvedScope =
  | { kind: 'pending' }
  | { kind: 'all'; readOnly: true }
  | { kind: 'environment'; environment: RegisteredEnvironment }
  | { kind: 'blocked'; reason: string };
export interface ObservationIdentity {
  readonly principalKey: string;
  readonly sessionEpoch: string;
  /** Explicit local invalidation epoch; NOT an invented server permission version. */
  readonly permissionEpoch: string;
}
export interface LastValidatedSelection {
  readonly identity: ObservationIdentity;
  readonly environmentId: string;
}
export function validIdentity(value: ObservationIdentity): boolean {
  return [value.principalKey, value.sessionEpoch, value.permissionEpoch]
    .every(part => typeof part === 'string' && part.trim().length > 0);
}
export function sameIdentity(a: ObservationIdentity, b: ObservationIdentity): boolean {
  return validIdentity(a) && validIdentity(b) && a.principalKey === b.principalKey
    && a.sessionEpoch === b.sessionEpoch && a.permissionEpoch === b.permissionEpoch;
}
